import { useEffect } from "react";

// Šalje visinu dokumenta parentu kad god se sadržaj promijeni.
export function useIframeAutoHeight() {
  useEffect(() => {
    if (window.parent === window) return;

    const send = () => {
      const height = document.documentElement.scrollHeight;
      // U produkciji zamijeniti "*" domenom klijenta radi sigurnosti,
      // npr. "<https://www.klijent.hr>"
      window.parent.postMessage({ type: "fiat-form-height", height }, "*");
    };

    send();
    const ro = new ResizeObserver(send);
    ro.observe(document.body);
    window.addEventListener("load", send);

    return () => {
      ro.disconnect();
      window.removeEventListener("load", send);
    };
  }, []);
}